/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Media Blog API
 * API сервиса статей (MVP).
 * OpenAPI spec version: 1.12.0
 */
import { fetcher } from '../../../utils/fetcher';
import type {
  EntityCreateArticleReq,
  EntityCreateArticleResp,
  EntityGetArticleResp,
  EntityListArticlesResp,
  EntityUpdateArticleReq,
  ErrorhandlerErrorResponse,
  GetAdminV1ArticlesParams,
  GetV1ArticlesParams,
} from '../../models';

/**
 * Retrieve a list of articles by tag, **categories (many-to-many)**, rubrics, and date range
 * @summary List articles with filters
 */
export type getAdminV1ArticlesResponse200 = {
  data: EntityListArticlesResp;
  status: 200;
};

export type getAdminV1ArticlesResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getAdminV1ArticlesResponseComposite =
  | getAdminV1ArticlesResponse200
  | getAdminV1ArticlesResponse500;

export type getAdminV1ArticlesResponse = getAdminV1ArticlesResponseComposite & {
  headers: Headers;
};

export const getGetAdminV1ArticlesUrl = (params?: GetAdminV1ArticlesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['category_ids', 'importance_level', 'rubric_id'];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) =>
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      );
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/admin/v1/articles?${stringifiedParams}`
    : `/admin/v1/articles`;
};

export const getAdminV1Articles = async (
  params?: GetAdminV1ArticlesParams,
  options?: RequestInit
): Promise<getAdminV1ArticlesResponse> => {
  return fetcher<getAdminV1ArticlesResponse>(getGetAdminV1ArticlesUrl(params), {
    ...options,
    method: 'GET',
  });
};

/**
 * Create a new article with title, content, tags, **categories (many-to-many)**, rubrics, importance_level and publish date
 * @summary Create a new article
 */
export type postAdminV1ArticlesResponse200 = {
  data: EntityCreateArticleResp;
  status: 200;
};

export type postAdminV1ArticlesResponse400 = {
  data: ErrorhandlerErrorResponse;
  status: 400;
};

export type postAdminV1ArticlesResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type postAdminV1ArticlesResponseComposite =
  | postAdminV1ArticlesResponse200
  | postAdminV1ArticlesResponse400
  | postAdminV1ArticlesResponse500;

export type postAdminV1ArticlesResponse =
  postAdminV1ArticlesResponseComposite & {
    headers: Headers;
  };

export const getPostAdminV1ArticlesUrl = () => {
  return `/admin/v1/articles`;
};

export const postAdminV1Articles = async (
  entityCreateArticleReq: EntityCreateArticleReq,
  options?: RequestInit
): Promise<postAdminV1ArticlesResponse> => {
  return fetcher<postAdminV1ArticlesResponse>(getPostAdminV1ArticlesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(entityCreateArticleReq),
  });
};

/**
 * Retrieve an article by its unique ID or slug
 * @summary Get an article by ID
 */
export type getAdminV1ArticlesIdResponse200 = {
  data: EntityGetArticleResp;
  status: 200;
};

export type getAdminV1ArticlesIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type getAdminV1ArticlesIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getAdminV1ArticlesIdResponseComposite =
  | getAdminV1ArticlesIdResponse200
  | getAdminV1ArticlesIdResponse404
  | getAdminV1ArticlesIdResponse500;

export type getAdminV1ArticlesIdResponse =
  getAdminV1ArticlesIdResponseComposite & {
    headers: Headers;
  };

export const getGetAdminV1ArticlesIdUrl = (id: string) => {
  return `/admin/v1/articles/${id}`;
};

export const getAdminV1ArticlesId = async (
  id: string,
  options?: RequestInit
): Promise<getAdminV1ArticlesIdResponse> => {
  return fetcher<getAdminV1ArticlesIdResponse>(getGetAdminV1ArticlesIdUrl(id), {
    ...options,
    method: 'GET',
  });
};

/**
 * Update article content by ID. Use category_ids to set categories (M2M).
 * @summary Update an existing article
 */
export type putAdminV1ArticlesIdResponse200 = {
  data: string;
  status: 200;
};

export type putAdminV1ArticlesIdResponse400 = {
  data: ErrorhandlerErrorResponse;
  status: 400;
};

export type putAdminV1ArticlesIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type putAdminV1ArticlesIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type putAdminV1ArticlesIdResponseComposite =
  | putAdminV1ArticlesIdResponse200
  | putAdminV1ArticlesIdResponse400
  | putAdminV1ArticlesIdResponse404
  | putAdminV1ArticlesIdResponse500;

export type putAdminV1ArticlesIdResponse =
  putAdminV1ArticlesIdResponseComposite & {
    headers: Headers;
  };

export const getPutAdminV1ArticlesIdUrl = (id: string) => {
  return `/admin/v1/articles/${id}`;
};

export const putAdminV1ArticlesId = async (
  id: string,
  entityUpdateArticleReq: EntityUpdateArticleReq,
  options?: RequestInit
): Promise<putAdminV1ArticlesIdResponse> => {
  return fetcher<putAdminV1ArticlesIdResponse>(getPutAdminV1ArticlesIdUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(entityUpdateArticleReq),
  });
};

/**
 * Delete an article by ID
 * @summary Delete an article
 */
export type deleteAdminV1ArticlesIdResponse204 = {
  data: string;
  status: 204;
};

export type deleteAdminV1ArticlesIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type deleteAdminV1ArticlesIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type deleteAdminV1ArticlesIdResponseComposite =
  | deleteAdminV1ArticlesIdResponse204
  | deleteAdminV1ArticlesIdResponse404
  | deleteAdminV1ArticlesIdResponse500;

export type deleteAdminV1ArticlesIdResponse =
  deleteAdminV1ArticlesIdResponseComposite & {
    headers: Headers;
  };

export const getDeleteAdminV1ArticlesIdUrl = (id: string) => {
  return `/admin/v1/articles/${id}`;
};

export const deleteAdminV1ArticlesId = async (
  id: string,
  options?: RequestInit
): Promise<deleteAdminV1ArticlesIdResponse> => {
  return fetcher<deleteAdminV1ArticlesIdResponse>(
    getDeleteAdminV1ArticlesIdUrl(id),
    {
      ...options,
      method: 'DELETE',
    }
  );
};

/**
 * Triggers a full reindex of all articles for the search engine
 * @summary Reindex all articles
 */
export type postAdminV1ReindexResponse200 = {
  data: string;
  status: 200;
};

export type postAdminV1ReindexResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type postAdminV1ReindexResponseComposite =
  | postAdminV1ReindexResponse200
  | postAdminV1ReindexResponse500;

export type postAdminV1ReindexResponse = postAdminV1ReindexResponseComposite & {
  headers: Headers;
};

export const getPostAdminV1ReindexUrl = () => {
  return `/admin/v1/reindex`;
};

export const postAdminV1Reindex = async (
  options?: RequestInit
): Promise<postAdminV1ReindexResponse> => {
  return fetcher<postAdminV1ReindexResponse>(getPostAdminV1ReindexUrl(), {
    ...options,
    method: 'POST',
  });
};

/**
 * Retrieve a list of articles by tag, **categories (many-to-many)**, rubrics, and date range
 * @summary List articles with filters
 */
export type getV1ArticlesResponse200 = {
  data: EntityListArticlesResp;
  status: 200;
};

export type getV1ArticlesResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getV1ArticlesResponseComposite =
  | getV1ArticlesResponse200
  | getV1ArticlesResponse500;

export type getV1ArticlesResponse = getV1ArticlesResponseComposite & {
  headers: Headers;
};

export const getGetV1ArticlesUrl = (params?: GetV1ArticlesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['category_ids', 'importance_level', 'rubric_id'];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) =>
        normalizedParams.append(key, v === null ? 'null' : v.toString())
      );
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/articles?${stringifiedParams}`
    : `/v1/articles`;
};

export const getV1Articles = async (
  params?: GetV1ArticlesParams,
  options?: RequestInit
): Promise<getV1ArticlesResponse> => {
  return fetcher<getV1ArticlesResponse>(getGetV1ArticlesUrl(params), {
    ...options,
    method: 'GET',
  });
};

/**
 * Retrieve an article by its unique ID or slug
 * @summary Get an article by ID
 */
export type getV1ArticlesIdResponse200 = {
  data: EntityGetArticleResp;
  status: 200;
};

export type getV1ArticlesIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type getV1ArticlesIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getV1ArticlesIdResponseComposite =
  | getV1ArticlesIdResponse200
  | getV1ArticlesIdResponse404
  | getV1ArticlesIdResponse500;

export type getV1ArticlesIdResponse = getV1ArticlesIdResponseComposite & {
  headers: Headers;
};

export const getGetV1ArticlesIdUrl = (id: string) => {
  return `/v1/articles/${id}`;
};

export const getV1ArticlesId = async (
  id: string,
  options?: RequestInit
): Promise<getV1ArticlesIdResponse> => {
  return fetcher<getV1ArticlesIdResponse>(getGetV1ArticlesIdUrl(id), {
    ...options,
    method: 'GET',
  });
};
